// extracted by mini-css-extract-plugin
export default {"advtBlock":"Advt_advtBlock__19++l","title":"Advt_title__Rr+JM","titleLine2":"Advt_titleLine2__jml8J","qrsWrapper":"Advt_qrsWrapper__RBQN9","qrCode":"Advt_qrCode__bXqQ2"};